import { render, staticRenderFns } from "./ShippingRateCreate.vue?vue&type=template&id=e076c5dc&scoped=true&"
import script from "./ShippingRateCreate.vue?vue&type=script&lang=js&"
export * from "./ShippingRateCreate.vue?vue&type=script&lang=js&"
import style0 from "./ShippingRateCreate.vue?vue&type=style&index=0&id=e076c5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e076c5dc",
  null
  
)

export default component.exports